import i18n, { init } from "i18next";

import Uz from './TranslateUz/uz.json'
import { initReactI18next } from "react-i18next";
import cookie from 'react-cookies'

// Komponentlardagi matnlar: kalit — o'zbekcha matnning o'zi, t("Ijaraga uylar").
// O'zbek tilida kalit o'zi ko'rsatiladi; ruscha/inglizcha lug'atlar locale/dict/*.ru.json va *.en.json da
// (har bir bo'lim alohida faylda) — dictRu.js / dictEn.js da birlashtiriladi.
// Tezlik: ru/en lug'atlari asosiy JS'ning ~37% edi — endi alohida chunk, faqat o'sha til tanlanganda yuklanadi.
const LOADERS = {
    ru: () => import(/* webpackChunkName: "i18n-ru" */ './dictRu'),
    en: () => import(/* webpackChunkName: "i18n-en" */ './dictEn'),
};

/** Tilning lug'ati yuklanganiga ishonch hosil qiladi (o'zbekcha — doim tayyor) */
export async function ensureLanguage(lng) {
    if (!LOADERS[lng] || i18n.hasResourceBundle(lng, 'translation')) return;
    try {
        const m = await LOADERS[lng]();
        i18n.addResourceBundle(lng, 'translation', m.default, true, true);
    } catch { /* tarmoq xatosi — o'zbekcha matn ko'rinadi (fallback: kalitning o'zi) */ }
}

const saved = cookie.load('tilYMed');
export const initialLanguage = ['uz', 'ru', 'en'].includes(saved) ? saved : 'uz';

i18n.use(initReactI18next)
init({
    resources: { uz: { translation: Uz } },
    lng: initialLanguage,
    // Kalitlar oddiy matn: nuqta va ikki nuqta ajratgich emas
    keySeparator: false,
    nsSeparator: false,
    // Tarjima topilmasa — o'zbekcha matn (kalitning o'zi) ko'rsatiladi
    fallbackLng: false,
    returnEmptyString: false,
    partialBundledLanguages: true,
    detection: {
        order: ['path', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],
        caches: ['cookie']
    },

    interpolation: {
        escapeValue: false
    }
});

// Til almashtirilganda avval lug'at yuklanadi, keyin almashadi (aks holda bir lahza o'zbekcha matn chiqardi)
const changeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (lng, cb) => { await ensureLanguage(lng); return changeLanguage(lng, cb); };

// Tanlangan tilni saqlash (sahifa qayta yuklanganda tiklanadi)
i18n.on('languageChanged', (lng) => { cookie.save('tilYMed', lng, { path: '/' }); document.documentElement.lang = lng; });

export default i18n;
